//Dependecies
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { isMobileOnly } from 'react-device-detect';
//Databases
import Dimensions from '../../databases/dimensions';
import Tours from '../../databases/tours';
//Components
import Drawer02 from '../components/drawers/Drawer02';
import Drawer03 from '../components/drawers/Drawer03';
import Drawer04 from '../components/drawers/Drawer04';
import Menu02 from '../components/menus/Menu02';
import Navbar01 from '../components/navbars/Navbar01';
import Sidemenu02 from '../components/sidemenus/Sidemenu02';
import Thumbnail01 from '../components/thumbnails/Thumbnail01';
import Thumbnail02 from '../components/thumbnails/Thumbnail02';
import Virtual02 from '../components/virtual/Virtual02';
//Index
import Biz from '../../databases/biz';
import Portfolio from '../../databases/portfolio';
import PortfolioIndex from '../../databases/portfolioIndex';

const TourRouter = () =>
{
  const dispatch = useDispatch();

  const counter = useSelector(state => state.portfolio.counter);
  const portfolioArray = useSelector(state => state.portfolio.portfolioArray);
  const business = useSelector(state => state.portfolio.business);

  const tourArray = useSelector(state => state.tours.tourArray);
  const hidehotspots = useSelector(state => state.tours.hidehotspots);

  let { id } = useParams();

 /* DIMENSIONS */
 const height = window.innerHeight;

  /* LOADING PORTFOLIO */
  useEffect(() => 
  {    
    let portfolioIndex = [];

    for (let i = 0; i < Object.keys(PortfolioIndex).length; i++) 
    {
      let indexID = Object.keys(PortfolioIndex)[i];
      let index = PortfolioIndex[indexID];
      let credits = index.credits;
      let exist = credits.find(f1 => f1 === id);

      if(exist)
      {
        portfolioIndex.push(indexID);
      }
    }   

    dispatch({type: 'SET_PORTFOLIO_ARRAY', portfolioArray : portfolioIndex});
  }, [id, dispatch]);

  /* LOADING PORTFOLIO THUMBNAILS */
  useEffect(() => 
  {
    let tourArray = [];

    if(portfolioArray.length > 0)
    {
      let portfolio = portfolioArray.map((m1, i) => 
      {
        tourArray.push(Portfolio[m1].tour);
        return (
          <Thumbnail01
            key           = {i}
            counter       = {i}
            name          = {Portfolio[m1].info.name}
            images        = {Tours[Portfolio[m1].tour].images.button}
            highlight     = {counter === i ? true : false}
            width         = {height/4}
          />
        );
      });

      dispatch({type: 'SET_TOUR_ARRAY', tourArray : tourArray});
      dispatch({type: 'SET_PORTFOLIO', portfolio : portfolio});
    }
    
  }, [height, portfolioArray, counter, dispatch]);

  /* LOADING BUSINESS */
  useEffect(() => 
  {
    let exist =  Object.keys(Biz).find(f1 => Biz[f1].info.username === id);
    let business = Biz[exist];

    dispatch({type: 'SET_PORTFOLIO_BIZ', business : business});
  }, [id, dispatch]);

  /* LOADING TOURS */
  useEffect(() => 
  {
    let constructionCredits = null;
    let designCredits = null;
    let imageCredits = null;

    if(portfolioArray.length > 0)
    {
      constructionCredits = Object.keys(Portfolio[portfolioArray[counter]].credits.construction).map((m1, i) => 
      {
        let text = m1;
        let bizName = Portfolio[portfolioArray[counter]].credits.construction[m1];
        let bizID = Object.keys(Biz).find(f1 => Biz[f1].info.username === bizName);        

        if(bizID)
        { 
          let biz =  Biz[bizID];
          return(
            <Thumbnail02
              key           = {i}
              biz           = {bizName}
              text          = {text}
              image         = {biz.images.thumbnail}
              placeholder   = {biz.images.thumbnailPlaceholder}
              width         = {height/4}
            />
          );
        }
        else
        {
          return null;
        }
      });
      
      for (const key in constructionCredits) {
        if (constructionCredits[key] === null) 
        {
          delete constructionCredits[key];
        }
      }
      
      designCredits = Object.keys(Portfolio[portfolioArray[counter]].credits.design).map((m1, i) => 
      {
        let text = m1;
        let bizName = Portfolio[portfolioArray[counter]].credits.design[m1];
        let bizID = Object.keys(Biz).find(f1 => Biz[f1].info.username === bizName);        

        if(bizID)
        { 
          let biz =  Biz[bizID];
          return(
            <Thumbnail02
              key           = {i}
              biz           = {bizName}
              text          = {text}
              image         = {biz.images.thumbnail}
              placeholder   = {biz.images.thumbnailPlaceholder}
              width         = {height/4}
            />
          );
        }
        else
        {
          return null;
        }
      });
      
      for (const key in designCredits) {
        if (designCredits[key] === null) 
        {
          delete designCredits[key];
        }
      }

      imageCredits = Object.keys(Portfolio[portfolioArray[counter]].credits.images).map((m1, i) => 
      {
        let text = m1;
        let bizName = Portfolio[portfolioArray[counter]].credits.images[m1];
        let bizID = Object.keys(Biz).find(f1 => Biz[f1].info.username === bizName);        

        if(bizID)
        { 
          let biz =  Biz[bizID];
          return(
            <Thumbnail02
              key           = {i}
              biz           = {bizName}
              text          = {text}
              image         = {biz.images.thumbnail}
              placeholder   = {biz.images.thumbnailPlaceholder}
              width         = {height/4}
            />
          );
        }
        else
        {
          return null;
        }
      });
      
      for (const key in imageCredits) {
        if (imageCredits[key] === null) 
        {
          delete imageCredits[key];
        }
      }
    }

    dispatch({type: 'SET_PORTFOLIO_CONSTRUCTION', construction : constructionCredits});
    dispatch({type: 'SET_PORTFOLIO_DESIGN', design : designCredits});
    dispatch({type: 'SET_PORTFOLIO_IMAGES', images : imageCredits});
    
  }, [height, portfolioArray, counter, dispatch]);
  
  return(
    <React.Fragment>
      {business &&
        <Drawer02
          data        = {business}
          isMobile    = {isMobileOnly}
        />
      }

      <Drawer03
        isMobile    = {isMobileOnly}
      />

      <Drawer04
        isMobile    = {isMobileOnly}
      />

      <Menu02
        height        = {Math.round(Dimensions.menu * height / 100)}
      />

      {Portfolio[portfolioArray[counter]] &&
        <Navbar01
          height      = {Math.round(Dimensions.navbar * height / 100)}
          info        = {Portfolio[portfolioArray[counter]]}
        />
      }

      <Sidemenu02
        height          = {Math.round((Dimensions.menu) * height / 100)}
        counter         = {counter}
        portfolioArray  = {portfolioArray}
      />

      {Portfolio[portfolioArray[counter]] && tourArray.length > 0 &&
        <Virtual02
          tourID          = {Portfolio[portfolioArray[counter]].tour}
          tourArray       = {tourArray}
          hidehotspots    = {hidehotspots}
        />
      }
    </React.Fragment>
  );
}

export default TourRouter;